import { render, staticRenderFns } from "./Setup.vue?vue&type=template&id=2532f249&scoped=true&"
import script from "./Setup.vue?vue&type=script&lang=js&"
export * from "./Setup.vue?vue&type=script&lang=js&"
import style0 from "./Setup.vue?vue&type=style&index=0&id=2532f249&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/jenkins_node_modules/doris/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2532f249",
  null
  
)

export default component.exports